<template>
  <header
    class="header sticky-header p-4 lg:px-0 min-h-[7rem]"
    :class="
      useFeatureState('cfg-seasonal-theme')?.value == true
        ? useFeatureValue('cfg-seasonal-theme')?.value?.bg ?? 'bg-black text-white'
        : ''
    "
  >
    <div
      class="px-4 lg:px-0 lg:container lg:mx-auto flex flex-col lg:flex-row justify-between gap-4 lg:gap-12"
    >
      <div
        class="store-logo-container flex justify-center lg:block items-center h-18 lg:h-auto"
        :class="
          useFeatureState('cfg-seasonal-theme')?.value == true &&
          useFeatureValue('cfg-seasonal-theme')?.value?.name != 'default'
            ? useFeatureValue('cfg-seasonal-theme')?.value?.bg
            : 'bg-white'
        "
      >
        <NavigationStoreLogo />
      </div>
      <div class="lg:block lg:grow">
        <div
          class="text-sm lg:text-base lg:float-right lg:flex lg:flex-col gap-2"
        >
          <div class="grid grid-cols-3 lg:flex gap-1 lg:gap-8 items-center">
            <NuxtLink v-if="featureStatePayback && basisPaybackFeature && localStore.paybackStore" :to="'/shop/payback'">
              <nuxt-img
                densities="x1"
                loading="lazy"
                class="min-h-[26px] max-h-8"
                provider="cloudflare"
                :src="'/97/27/77/05262c90ceebe43a34e6fdec70f562de6a/Payback-logo.svg'"
                :alt="'PAYBACK'"
              />
            </NuxtLink>
            <div class="col-span-2">
              <div class="flex gap-2 items-baseline lg:items-center">
                <BasicIcon class="w-4 text-primary" :name="'house-chimney-solid'" />
                <div>
                  {{ useCurrentStore()?.value?.street }} -
                  {{ useCurrentStore()?.value?.zip }} {{ useCurrentStore()?.value?.city }}
                </div>
              </div>
              <div
            class="storeOpening flex items-baseline lg:items-center gap-2"
            v-if="localStore?.openings"
          >
            <BasicIcon class="w-4 text-primary" :name="'clock-nine-regular'" />
            {{
              (function () {
                const days = [
                  "MONDAY",
                  "TUESDAY",
                  "WEDNESDAY",
                  "THURSDAY",
                  "FRIDAY",
                  "SATURDAY",
                  "SUNDAY",
                ];
                let openings = localStore?.openings;
                let currentDate = new Date();
                let today = currentDate.getDay() - 1;
                let now = currentDate.getHours() * 60 + currentDate.getMinutes();
                let firstOpenToday = null;
                let nextOpenToday = 1441;
                let lastOpenToday = null;
                let notOnBreak = false;
                for (let i = 0; i < openings?.length; i++) {
                  let opening = openings[i];
                  if (
                    days.indexOf(opening.dayFrom) <= today &&
                    today <= days.indexOf(opening.dayTo)
                  ) {
                    if (firstOpenToday == null || firstOpenToday > opening.timeFrom)
                      firstOpenToday = opening.timeFrom;
                    if (nextOpenToday > opening.timeFrom && opening.timeTo > now)
                      nextOpenToday = opening.timeFrom;
                    if (lastOpenToday == null || lastOpenToday < opening.timeTo)
                      lastOpenToday = opening.timeTo;
                    if (opening.timeFrom <= now && now <= opening.timeTo)
                      notOnBreak = true;
                  }
                }
                if (firstOpenToday == null || lastOpenToday == null) {
                  return "Heute geschlossen!";
                }
                if (firstOpenToday <= now && now <= lastOpenToday) {
                  if (notOnBreak)
                    return "Heute bis " + getTimeString(lastOpenToday) + " Uhr geöffnet";
                  else return "Geöffnet ab " + getTimeString(nextOpenToday) + " Uhr";
                } else if (now < firstOpenToday)
                  return "Geöffnet ab " + getTimeString(firstOpenToday) + " Uhr";
                else return "Heute bereits geschlossen!";
              })()
            }}
          </div>
          <div
            class="storeOpening flex items-center gap-2"
            v-else-if="
              localStore?.openingHours !== undefined &&
              localStore?.openingHours !== null &&
              localStore.openingHours.length > 0
            "
          >
            <BasicIcon class="w-4 text-primary" :name="'clock-nine-regular'" />
            <div
              class="flex gap-1 lg:grow lg:grid"
              style="grid-template-columns: auto auto"
            >
              <template v-for="range in localStore.openingHours" :key="range">
                <div style="text-transform: capitalize">
                  {{ range.dayFrom }}.<template v-if="range.dayFrom !== range.dayTo">
                    -
                    {{ range.dayTo }}.</template
                  >
                </div>
                <div>{{ range.timeFrom }} - {{ range.timeTo }} Uhr</div>
              </template>
            </div>
          </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </header>
</template>
<script setup lang="ts">
const today = new Date().getDay();
const openFrom = ref("So. geschlossen");
const openFrom2Morrow = ref("So. geschlossen");
const featureStatePayback = computed(() => useFeatureState('exsi-1556') && useCurrentStore().value.paybackStore);
const basisPaybackFeature = computed(
  () =>
    featureStatePayback.value
    && (useFeatureValue('exsi-1556').value?.name == 'basic'
      || useFeatureValue('exsi-1556').value?.name == 'redemption'
      || useFeatureValue('exsi-1556').value?.name == 'full')
);
const localStore = useCurrentStore()?.value;
const dayMapping = [
  { day: "mo", num: 1 },
  { day: "di", num: 2 },
  { day: "mi", num: 3 },
  { day: "do", num: 4 },
  { day: "fr", num: 5 },
  { day: "sa", num: 6 },
  { day: "so", num: 0 },
];

function getTimeString(timeInt) {
  var hours = Math.floor(timeInt / 60);
  hours = hours + "";
  while (hours.length < 2) hours = "0" + hours;
  var minutes = timeInt % 60;
  minutes = minutes + "";
  while (minutes.length < 2) minutes = "0" + minutes;
  return hours + ":" + minutes;
}

let opened = useCurrentStore()?.value?.openingHours?.find((open) =>
  dayMapping.find((dm) => dm.day == open.dayFrom && dm.num >= today && today != 0)
);
if (opened)
  openFrom.value =
    dayMapping
      .find((da) => da.num == today)
      ?.day.at(0)
      .toUpperCase() +
    dayMapping.find((da) => da.num == today)?.day.slice(1) +
    ". " +
    opened?.timeFrom +
    " - " +
    opened?.timeTo +
    " Uhr";

let opened2m = useCurrentStore()?.value?.openingHours?.find((open) =>
  dayMapping.find((dm) => dm.day == open.dayFrom && dm.num >= today + 1)
);
if (opened2m)
  openFrom2Morrow.value =
    dayMapping
      .find((da) => da.num == today + 1)
      ?.day.at(0)
      .toUpperCase() +
    dayMapping.find((da) => da.num == today + 1)?.day.slice(1) +
    ". " +
    opened2m?.timeFrom +
    " - " +
    opened2m?.timeTo +
    " Uhr";
</script>
<style>
.store-logo {
  min-height: 3em;
}
</style>
